import { PlatformMapLayerGroup, PlatformMapSceneId } from './types'

function setLayerVisible (layer: any, visible: boolean) {
  if (!layer) return
  if ('show' in layer) layer.show = visible
  else if ('enabled' in layer) layer.enabled = visible
}

export class BusinessLayerRegistry {
  private groups = new Map<PlatformMapSceneId, Map<string, PlatformMapLayerGroup>>()

  register (sceneId: PlatformMapSceneId, group: PlatformMapLayerGroup) {
    let sceneGroups = this.groups.get(sceneId)
    if (!sceneGroups) {
      sceneGroups = new Map<string, PlatformMapLayerGroup>()
      this.groups.set(sceneId, sceneGroups)
    }
    this.unregister(sceneId, group.id)
    sceneGroups.set(group.id, group)
  }

  unregister (sceneId: PlatformMapSceneId, groupId: string) {
    const sceneGroups = this.groups.get(sceneId)
    const group = sceneGroups?.get(groupId)
    if (!group) return
    group.layers.forEach(layer => setLayerVisible(layer, false))
    sceneGroups?.delete(groupId)
    if (!sceneGroups?.size) this.groups.delete(sceneId)
  }

  activateScene (sceneId: PlatformMapSceneId) {
    this.groups.forEach((sceneGroups, registeredSceneId) => {
      const visible = registeredSceneId === sceneId
      sceneGroups.forEach(group => {
        group.visible = visible
        group.layers.forEach(layer => setLayerVisible(layer, visible))
      })
    })
  }

  clearScene (sceneId: PlatformMapSceneId) {
    const sceneGroups = this.groups.get(sceneId)
    sceneGroups?.forEach(group => group.layers.forEach(layer => setLayerVisible(layer, false)))
    this.groups.delete(sceneId)
  }
}
